var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"welcome_wrap"},[_c('h1',{staticClass:"text-center align-self-center"},[_vm._v("Добро пожаловать")])])}
var staticRenderFns = []

export { render, staticRenderFns }